import React from "react";
import UnitGuideEditorContent from "./UnitGuideEditorContent";

function UnitGuideTab({ courseId }) {
  return (
    <div className="curriculum-unit-guide-tab">
      <UnitGuideEditorContent courseId={courseId} />
    </div>
  );
}

export default UnitGuideTab;
